import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Formik} from "formik";
import {
    Portlet,
    PortletBody,
} from "../../../partials/content/Portlet";
import Notice from "../../../partials/content/Notice";
import {LinearProgress, TextField} from '@material-ui/core';
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import validator from './validator';
import {updatePassword} from "../../../crud/auth.crud";
import Translate from "../../../utils/utils";

function Password() {
    const currentUser = useSelector(store => store.auth.user);
    const [isLoading, setIsLoading] = useState(false);
    const {reset_password} = currentUser;
    const dispatch = useDispatch();
    const values = {
        password: "",
        password_confirmation: "",
        current_password: "",
    }

    const [initialValues, setInitialValues] = useState(values);

    const handleSubmit = (values, {setStatus, setSubmitting, setErrors}) => {
        setIsLoading(true);
        updatePassword(values)
            .then(({data: {message}}) => {
                const user = Object.assign({}, currentUser);
                user.reset_password = false;
                dispatch({type: "PasswordUpdated", payload: user});
                setSubmitting(false);
                setStatus("Password updated");
                setInitialValues({
                    password: "",
                    password_confirmation: "",
                    current_password: ""
                });
                setIsLoading(false);
                Swal.fire({
                    icon: 'success',
                    text: 'Password updated'
                });
            })
            .catch((error) => {
                setIsLoading(false);
                const {response: {data: {errors = []}} = {}} = error;
                setSubmitting(false);
                setErrors(errors);
            });
        return false;
    }

    return (
        <>{reset_password &&
        <Notice icon="flaticon-warning kt-font-primary">
            You must reset your password to continue.
        </Notice>
        }
            <div className="kt-form kt-form--label-right">
                <Portlet>
                    <PortletBody>
                        <div className="kt-section kt-margin-t-30">
                            <div className="kt-section__body">
                                <div className="form-group">
                                    {isLoading && <LinearProgress color="secondary"/>}
                                    <Formik
                                        initialValues={initialValues}

                                        onSubmit={handleSubmit}
                                        enableReinitialize={true}
                                    >
                                        {({
                                              values,
                                              status,
                                              errors,
                                              touched,
                                              handleChange,
                                              handleBlur,
                                              handleSubmit,
                                              isSubmitting
                                          }) => (
                                            <form
                                                noValidate={true}
                                                autoComplete="off"
                                                className="kt-form"
                                                onSubmit={handleSubmit}
                                            >
                                                {status && (
                                                    <div role="alert" className="alert alert-danger">
                                                        <div className="alert-text">{status}</div>
                                                    </div>
                                                )}

                                                <TextField
                                                    type="password"
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    label={<Translate id="PASSWORD.FORM.CURRENT_PASSWORD"/>}
                                                    name="current_password"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.current_password}
                                                    helpertext={touched.current_password && errors.current_password}
                                                    error={Boolean(touched.current_password && errors.current_password)}
                                                />

                                                <TextField
                                                    type="password"
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    label={<Translate id="PASSWORD.FORM.NEW_PASSWORD"/>}
                                                    name="password"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.password}
                                                    helpertext={touched.password && errors.password}
                                                    error={Boolean(touched.password && errors.password)}
                                                />

                                                <TextField
                                                    type="password"
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    label={<Translate id="PASSWORD.FORM.CONFIRM_PASSWORD"/>}
                                                    name="password_confirmation"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.password_confirmation}
                                                    helpertext={touched.password_confirmation && errors.password_confirmation}
                                                    error={Boolean(touched.password_confirmation && errors.password_confirmation)}
                                                />


                                                <div className="kt-login__actions mt-3">
                                                    <button
                                                        type="submit"
                                                        disabled={isSubmitting || Object.is(initialValues, values)}
                                                        className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}
                                                    >
                                                        <Translate id="DIALOG.FORM.BUTTON.UPDATE"/>
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </PortletBody>
                </Portlet>
            </div>
        </>
    );
}

export default injectIntl(withRouter(Password));
